import type { QueryClient, QueryKey } from "@tanstack/react-query";
import type { useTRPC } from "@/trpc";
import {
  vaultRecordQueryKey,
  type CredentialVaultScope,
} from "./credential-vault-scope";

/** Native organization edits also update the BU's local roster projection. */
export async function invalidateCredentialVaultRecord({
  queryClient,
  trpc,
  scope,
}: {
  queryClient: QueryClient;
  trpc: ReturnType<typeof useTRPC>;
  scope: CredentialVaultScope;
}) {
  const keys: QueryKey[] = [vaultRecordQueryKey(trpc, scope)];
  if (scope.kind === "organization") {
    const input = {
      organizationBusinessUnitId: scope.organizationBusinessUnitId,
    };
    if (scope.expectedAffiliationId) {
      keys.push(
        trpc.providerWorkspace.list.queryKey(input),
        trpc.providerWorkspace.getProvider.queryKey(input),
        trpc.providerWorkspace.rosterDetails.queryKey(input),
        trpc.providerWorkspace.listInvitations.queryKey(input),
      );
    }
    // Partial keys refresh every filter/page for this BU without invalidating
    // another organization's roster or the provider's account record.
    keys.push(
      trpc.providers.listCredentialSummary.queryKey(input),
      trpc.providers.getCredentialSummaryStats.queryKey(input),
      trpc.organizationBusinessUnitAffiliation.listInvitations.queryKey(input),
      trpc.organizationBusinessUnitAffiliation.listForBusinessUnit.queryKey(
        input,
      ),
    );
  }
  await Promise.all(
    keys.map((queryKey) => queryClient.invalidateQueries({ queryKey })),
  );
}
